import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PWADetectorService, ScreenService } from '../../../../../shared/services/general';

@Component({
    selector: 'app-standing-order-done-dialog',
    templateUrl: './standing-order-done-dialog.component.html',
    styleUrls: ['./standing-order-done-dialog.component.scss'],
})
export class StandingOrderDoneDialogComponent implements OnInit, OnDestroy {
    @Input() public popupVisible = false;
    @Input() public patientId: number = -1;
    @Input() public mode: 'create' | 'update' = 'create';
    public isPhone: boolean = true;
    private onDestroy$: Subject<void> = new Subject<void>();

    constructor(private router: Router,
                private pwaDetectorService: PWADetectorService,
                private screen: ScreenService ) {
    }

    public ngOnInit() {
        this.isPhone = this.screen.sizes['screen-x-small'];
        this.screen.changed.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
            this.isPhone = this.screen.sizes['screen-x-small'];
        });
    }

    public async redirectToNew() {
        if (this.pwaDetectorService.isPWA()) {
            await this.router.navigate(['/secured/standing-orders/form']);
        } else {
            const url = this.router.serializeUrl(
                this.router.createUrlTree(['/secured/standing-orders/form']),
            );
            window.open(url, '_self');
        }
    }

    public async redirectToNewWithPatient() {
        if (this.pwaDetectorService.isPWA()) {
            await this.router.navigate(['/secured/standing-orders/form', {
                patientId: this.patientId
            }]);
        } else {
            const url = this.router.serializeUrl(
                this.router.createUrlTree(['/secured/standing-orders/form', {
                    patientId: this.patientId
                }]),
            );
            window.open(url, '_self');
        }
    }

    public async redirectToSearch() {
        await this.router.navigateByUrl('/secured/standing-orders/search');
    }

    public ngOnDestroy(): void {
        this.onDestroy$.next(); this.onDestroy$.complete()
    }
}
